





































import {Prop, Watch} from "vue-property-decorator";
import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Timeout, WatchObjectProperties} from '@/shared/decorator';

import storeDevis, {DevisFilter} from '@/stores/modules/devis';

import InputDateFilter from '@/components/Input/DateFilter.vue';

@Component({
	components: {
		InputDateFilter,
	}
})
export default class CrudDevisFilter extends Vue {

	@Prop({ type: Boolean, default: false}) reduce!: boolean;

	@Stored(() => storeDevis) private page!: number;
	@Stored(() => storeDevis) private filters!: DevisFilter;

	@WatchObjectProperties('filters', DevisFilter)
	@Timeout()
	private filtersWatcher(): void {
		this.page = 0;
		storeDevis.dispatch('getC', { filters: true });
	}

	public mounted() {
		this.typeWatcher();
	}

	@Watch('type')
	private typeWatcher(): void {
		this.filters.clear();

	}

}
